module.exports = __webpack_public_path__ + "img/nowruz-1403-logo.379e4a6.svg";